<!-- Cuadros grises que simulan el contenido (tarjetas, barra, gráfico, tablas): la misma forma que lo real, sin salto al llegar los datos -->
<div class="flex flex-col gap-[20px]" role="status" aria-busy="true" aria-label="Cargando">
  <section class="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-4" *ngIf="tarjetas > 0">
    <div class="kb-card p-[18px] flex flex-col gap-1.5" *ngFor="let i of seq(tarjetas)">
      <span class="kb-skeleton h-5 w-32"></span>
      <span class="kb-skeleton h-[39px] w-3/4"></span>
      <span class="kb-skeleton h-4 w-1/2"></span>
    </div>
  </section>

  <section class="kb-card" *ngIf="barra">
    <div class="kb-card-header"><span class="kb-skeleton h-5 w-56"></span></div>
    <div class="flex flex-col gap-3 px-[24px] py-[20px]">
      <span class="kb-skeleton h-7 w-full"></span>
      <div class="flex gap-4"><span class="kb-skeleton h-4 w-28"></span><span class="kb-skeleton h-4 w-28"></span><span class="kb-skeleton h-4 w-28"></span></div>
    </div>
  </section>

  <section class="kb-card" *ngIf="grafico">
    <div class="kb-card-header"><div class="flex flex-col gap-2"><span class="kb-skeleton h-5 w-64"></span><span class="kb-skeleton h-4 w-96 max-w-full"></span></div></div>
    <div class="flex flex-col gap-3 px-[24px] py-[20px]">
      <div class="kb-skeleton h-[280px] w-full"></div>
      <div class="flex gap-4"><span class="kb-skeleton h-4 w-24"></span><span class="kb-skeleton h-4 w-28"></span></div>
    </div>
  </section>

  <ng-container *ngIf="filas > 0">
    <ng-container *ngIf="envuelto; else soloFilas">
      <section class="kb-card" *ngFor="let b of seq(bloques)">
        <div class="kb-card-header"><div class="flex flex-col gap-2"><span class="kb-skeleton h-5 w-56"></span><span class="kb-skeleton h-4 w-80 max-w-full"></span></div></div>
        <div class="flex flex-col gap-3 px-[24px] py-[20px]">
          <span class="kb-skeleton h-10 w-full"></span>
          <span class="kb-skeleton h-8 w-full" *ngFor="let i of seq(filas)"></span>
        </div>
      </section>
    </ng-container>
    <ng-template #soloFilas>
      <div class="flex flex-col gap-2">
        <span class="kb-skeleton h-10 w-full"></span>
        <span class="kb-skeleton h-8 w-full" *ngFor="let i of seq(filas)"></span>
      </div>
    </ng-template>
  </ng-container>
</div>
